import { Image } from "@tiptap/extension-image";
import CustomerResourceService from "../../../services/CustomerResourceService.ts";
import type { NodeViewProps } from "@tiptap/core";
import { NodeViewWrapper } from "./solid/NodeViewWrapper.tsx";
import { SolidNodeViewRenderer } from "./solid/NodeViewRenderer.tsx";
import { isNil, omit } from "lodash-es";
import { createMemo } from "solid-js";

const CUSTOMER_RESOURCE_ENDPOINT_PATTERN =
  /^https?:\/\/api\.moreapp\.(?:dev|com)\/api\/v1\.0\/common\/customers\/(?<customerId>\d+)\/resources\/(?<resourceId>[a-fA-F0-9]+)$/;

export const CustomImage = Image.extend({
  addNodeView: () => SolidNodeViewRenderer(ImageNodeView),

  addAttributes: () => ({
    // Default 'Image' attributes
    src: {
      default: null,
    },
    alt: {
      default: null,
    },
    title: {
      default: null,
    },
    // Custom attribute
    style: {
      default: null,
    },
  }),
}).configure({
  allowBase64: true,
});

const ImageNodeView = (props: NodeViewProps) => {
  // The persisted 'src' for customer resource images is a deprecated URL and only works for 'public' resources. Therfor
  // we cannot use it to display the image. Instead, we need to fetch the secure URI for the resource.
  const src = createMemo(() => {
    const srcAttrValue = props.node.attrs.src;
    if (typeof srcAttrValue == "string") {
      const match = CUSTOMER_RESOURCE_ENDPOINT_PATTERN.exec(srcAttrValue);
      if (!isNil(match?.groups)) {
        const resourceId = match.groups["resourceId"];
        return CustomerResourceService.getSecureUriQuery(resourceId).data;
      }
    }

    return srcAttrValue;
  });

  return (
    <NodeViewWrapper data-drag-handle>
      {/* oxlint-disable-next-line jsx-a11y/alt-text -- 'alt' is added via 'props.node.attrs' */}
      <img
        {...omit(props.node.attrs, "src")}
        classList={{ "outline-default": props.selected }}
        src={src()}
        data-node-view-anchor
      />
    </NodeViewWrapper>
  );
};
